<template>
  <WdsText class="tw-truncate">{{ assignmentCompanyName }}</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestAssignmentCompanyColumn = graphql(`
  fragment PaymentRequestAssignmentCompanyColumn on PaymentRequest {
    id
    hire {
      id
      company {
        id
        name
      }
    }
    company {
      id
      name
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof PaymentRequestAssignmentCompanyColumn> }>()
const column = computed(() => useFragment(PaymentRequestAssignmentCompanyColumn, props.row))

const assignmentCompanyName = computed(
  () =>
    // Try to get company from hire first, then fallback to direct company
    column.value.hire?.company?.name || column.value.company?.name || 'Unknown',
)
</script>

<style scoped></style>
